<div class="flex justify-between px-4 pt-4">
  <div class="flex items-center gap-2">
    <h2 class="text-lg font-semibold">Asignar Territorios</h2>
    <mat-icon class="text-blue-500">add_location</mat-icon>
  </div>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content>
  <!-- Loading State -->
  @if (modalService.isLoading()) {
    <div class="flex justify-center items-center py-8">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else {
    <!-- Client Info -->
    @if (modalService.businessPartner(); as bp) {
      <div class="client-info-card mb-4 p-3 bg-gray-50 rounded-lg">
        <div class="flex items-center gap-2">
          <mat-icon class="text-gray-500">person</mat-icon>
          <span class="font-semibold">{{ modalService.clientDisplayName() }}</span>
          <mat-icon
            svgIcon="heroicons_outline:rocket-launch"
            class="icon-size-4 cursor-pointer hover:text-blue-600 hover:animate-bounce"
            matTooltip="Ver en Socios de Negocio"
            (click)="navigateToClient()">
          </mat-icon>
        </div>
        @if (bp.commercialName) {
          <div class="text-sm text-gray-500 ml-8">{{ bp.commercialName }}</div>
        }
      </div>
    }

    <!-- Stepper -->
    <mat-horizontal-stepper #stepper [linear]="false" (selectionChange)="onStepChange($event)">
      <!-- Step 1: Territorios -->
      <mat-step [completed]="modalService.canProceedToAddress()" label="Territorios">
        <app-territory-step></app-territory-step>
      </mat-step>

      <!-- Step 2: Dirección -->
      <mat-step label="Dirección">
        <app-address-step></app-address-step>
      </mat-step>
    </mat-horizontal-stepper>
  }
</div>

<div mat-dialog-actions align="end" class="gap-2 pt-4">
  <button mat-button (click)="onCancel()">Cancelar</button>

  @if (currentStepIndex() === 0) {
    <button
      mat-flat-button
      color="primary"
      [disabled]="!modalService.canProceedToAddress()"
      (click)="goToAddressStep()">
      Siguiente ({{ modalService.selectedTerritoriesCount() }})
      <mat-icon>arrow_forward</mat-icon>
    </button>
  }

  @if (currentStepIndex() === 1) {
    <button mat-button (click)="goToTerritoriesStep()">
      <mat-icon>arrow_back</mat-icon>
      Atrás
    </button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!modalService.canSave() || modalService.isSaving()"
      (click)="save()">
      @if (modalService.isSaving()) {
        <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
        Guardando...
      } @else {
        Asignar Territorios
      }
    </button>
  }
</div>
